export default __webpack_public_path__ + "static/media/cogs.a8518351.svg";